import React, { useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { SearchBox } from 'react-instantsearch-dom'
import { orderBy } from 'lodash'

import trads from '../../intl/trads.json'
import SearchActionsGeneric from '../searchActionsGeneric'
import CustomFilters from '../search/filters'
import ClearFilters from '../clearFilters'
import Accordion from '../accordion'

import plusIcon from '../../icons/plus.svg'
import minusIcon from '../../icons/minus.svg'

import { setFiltersChange, setFiltersThemesNumber, setFiltersHolderNumber, setFiltersYearNumber, setFiltersTypeNumber } from '../../store/actions'

const SearchActions = ({type}) => {
  const lang = useSelector(state => state.lang)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setFiltersChange(0))
    dispatch(setFiltersThemesNumber(0))
    dispatch(setFiltersYearNumber(0))
    dispatch(setFiltersTypeNumber(0))
    dispatch(setFiltersHolderNumber(0))
  }, [dispatch])

  const renderFilters = () => {
    return (
      <>
        <h2 className="font-alternate title-block mt-5 hidden lg:block">{trads[lang].search.filter}</h2>

        <h3 className="mt-9 mb-3">{trads[lang].newsroom.searchKeyword}</h3>
        <SearchBox 
          onInput={event => {
            if (event.currentTarget.value.length > 0) {
              event.currentTarget.closest('.ais-SearchBox').classList.add('has-clear')
            } else {
              event.currentTarget.closest('.ais-SearchBox').classList.remove('has-clear')
            }
          }}
          onReset={event => {
            event.currentTarget.closest('.ais-SearchBox').classList.remove('has-clear')
          }}
          translations={{ placeholder: trads[lang].newsroom.searchPlaceholder}} />

        { (type !== 'events') &&
          <h3 className="mt-9 mb-3">{trads[lang].search.filterBy}</h3>
        }

        { (type !== 'events') &&
          <>
            <Accordion
              newsroomList={true}
              filterType='themes'
              prefixClass="newsroom-accordion"
              button={trads[lang].newsroom.themes}
              iconClosed={plusIcon.url}
              iconOpen={minusIcon.url} >
                <CustomFilters
                  lang={lang} 
                  newsroomList={true}
                  attribute='mainTag'
                  transformItems={items =>
                    orderBy(items.map(item => ({
                      ...item,
                      label: item.label,
                    }) ), "label", "asc")
                  }
                />
            </Accordion>

            { (type === 'news' || type === 'document') &&
              <Accordion
                newsroomList={true}
                filterType='type'
                prefixClass="newsroom-accordion"
                button="Type"
                iconClosed={plusIcon.url}
                iconOpen={minusIcon.url} >
                  <CustomFilters
                    lang={lang} 
                    newsroomList={true}
                    attribute={type === 'news' ? 'contentType' : 'type'}
                    transformItems={items =>
                      orderBy(items.map(item => ({
                        ...item,
                        label: (type === 'news') ? trads[lang].search.contentTypes[item.label] : trads[lang].docTypes[item.label],
                      }) ), "label", "asc")
                    }
                  />
              </Accordion>
            }

            <Accordion
              newsroomList={true}
              filterType='year'
              prefixClass="newsroom-accordion"
              button={trads[lang].newsroom.year}
              iconClosed={plusIcon.url}
              iconOpen={minusIcon.url} >
                <CustomFilters
                  lang={lang} 
                  newsroomList={true}
                  attribute='year'
                  transformItems={items =>
                    orderBy(items.map(item => ({
                      ...item,
                      label: item.label,
                    }) ), "label", "desc")
                  }
                />
            </Accordion>
          </>
        }

        <ClearFilters classes="mt-10 mb-7 lg:mb-0" />
      </>
    )
  }

  return (
    <SearchActionsGeneric
      newsroomList={true}
      filtersPanel={renderFilters()}
      applyLabel={trads[lang].newsroom.apply} />
  )
}

export default SearchActions